type CameraFeedProps = {
	videoRef: React.RefObject<HTMLVideoElement>;
};

export const CameraFeed = ({ videoRef }: CameraFeedProps) => {
	return (
		<video
			ref={videoRef}
			autoPlay
			playsInline
			muted
			className="w-full h-full object-cover"
		/>
	);
};
